import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';

type TooltipProps = {
  width?: string;
  height?: string;
  position?: 'top' | 'bottom' | 'left' | 'right';
  background?: string;
  color?: string;
  id?: string;
};

const Tooltip = ({
  width,
  height,
  position = 'bottom',
  background = '#F8FBF1',
  color = 'black',
  id
}: TooltipProps) => {
  return (
    <ReactTooltip
      id={id}
      place={position}
      style={{
        width,
        height,
        maxWidth: '260px', // 🔥 prevent going out of page
        whiteSpace: 'normal', // 🔥 allow wrapping
        wordBreak: 'break-word', // 🔥 break long words
        background,
        color,
        boxShadow: '0 0 13px rgba(0, 0, 0, 0.2)',
        borderRadius: '12px',
        padding: '10px',
        fontSize: '14px',
        zIndex: '9999',
        fontWeight: '500'
      }}
    />
  );
};

export default Tooltip;
